$.fn.Episode = function() {
  let self = this
  self.player = undefined
  self.el = {
    play: self.find('.card-balado__play-btn'),
    icon: self.find('.icon-play'),
  }

  self.play = function() {
    if (!self.hasClass('card-balado--playing')) {
      self.player.play()
    }
    self.addClass('card-balado--playing')
    self.el.icon.removeClass('icon-play').addClass('icon-pause')
  }

  self.pause = function() {
    if (self.hasClass('card-balado--playing')) {
      self.player.pause()
    }
    self.removeClass('card-balado--playing')
    self.el.icon.removeClass('icon-pause').addClass('icon-play')
  }

  self.finish = function() {
    self.removeClass('card-balado--playing')
    self.el.icon.removeClass('icon-pause').addClass('icon-play')
  }

  self.clicked = function() {
    if (self.hasClass('card-balado--playing')) {
      self.pause()
    } else {
      self.play()
    }
    return false;
  }

  return function() {
    if (self.find('iframe').length > 0) {
      self.player = SC.Widget(self.find('iframe').get(0))
      self.player.bind(SC.Widget.Events.FINISH, self.finish)
      self.player.bind(SC.Widget.Events.PAUSE, self.pause)
      self.player.bind(SC.Widget.Events.PLAY, self.play)
      self.el.play.on('click', self.clicked)
    }
    return self
  }()
}

export default {
  init() {
    $('.card-balado').each(function() {
      $(this).Episode()
    })
  },
}
